import { render, staticRenderFns } from "./knowledge-trend.vue?vue&type=template&id=10fb4f5b&scoped=true"
import script from "./knowledge-trend.vue?vue&type=script&lang=js"
export * from "./knowledge-trend.vue?vue&type=script&lang=js"
import style0 from "./knowledge-trend.vue?vue&type=style&index=0&id=10fb4f5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fb4f5b",
  null
  
)

export default component.exports